export const VALID_TIME_UNITS = [
  "seconds",
  "minutes",
  "hours",
  "days",
  "weeks",
] as const;

export type TimeUnit = (typeof VALID_TIME_UNITS)[number];

export class TimePeriod {
  private amount: number;
  private time_unit: TimeUnit;

  constructor(amount: number, time_unit: TimeUnit) {
    this.setAmount(amount);
    this.setTimeUnit(time_unit);
  }

  getAmount(): number {
    return this.amount;
  }

  getTimeUnit(): TimeUnit {
    return this.time_unit;
  }

  setAmount(amount: number) {
    if (amount <= 0) {
      throw new Error("Amount must be greater than zero.");
    }
    this.amount = amount;
  }

  setTimeUnit(time_unit: TimeUnit) {
    if (!VALID_TIME_UNITS.includes(time_unit)) {
      throw new Error(
        `Invalid time_unit: ${time_unit}. Must be one of: ${VALID_TIME_UNITS.join(
          ", ",
        )}`,
      );
    }
    this.time_unit = time_unit;
  }

  toJSON() {
    return {
      amount: this.amount,
      time_unit: this.time_unit,
    };
  }
}
